/**
 * Wrapper para componentes lazy que necesitan Suspense
 * Se usa para rutas fuera del DashboardLayout
 */

import { Suspense, ReactNode } from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface LazyRouteWrapperProps {
  children: ReactNode;
}

export function LazyRouteWrapper({ children }: LazyRouteWrapperProps) {
  return <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>;
}

